import React from 'react';
import { useTrackingContext } from '../TrackingContext';

export type WizardSimpleOptions = {
  wizardName: string;
  actionType?: 'wizard' | 'select_filter' | 'select_sort' | 'select_page' | 'select_region';
  action:
    | 'close wizard'
    | 'field validation error'
    | 'proceed'
    | 'start'
    | 'submit'
    | 'wizard proceed'
    | 'wizard conclusion';
  actionDetail: string;
  wizardStep: number;
  applicationName?: string;
  wizardOutput?: string;
};

export const trackCustomWizard =
  (siteSection: string) =>
  ({
    action,
    actionType = 'wizard',
    actionDetail,
    wizardName,
    wizardStep,
    applicationName,
    wizardOutput,
  }: WizardSimpleOptions) => {
    window._satellite.track(`custom_track_wizard`, {
      action,
      actionDetail,
      wizardName,
      pageCategory: 'not available',
      actionType,
      pagePath: window.location.pathname,
      wizardStep: wizardStep.toString(),
      pageName: window.document.title,
      siteSection,
      applicationName,
      wizardOutput,
    });
  };

type TrackFormErrors = {
  fieldsErrors: string[];
} & Omit<WizardSimpleOptions, 'action'>;

export const useTrackingCustomWizardFormFieldError = ({
  fieldsErrors,
  ...rest
}: TrackFormErrors) => {
  const { trackCustomWizard } = useTrackingContext();
  const [loggedErrors, setLoggedErrors] = React.useState<string>('');

  React.useEffect(() => {
    const hasErrors = fieldsErrors.some((error) => Boolean(error));
    const newErrors = fieldsErrors.join(', ');

    if (hasErrors && loggedErrors !== newErrors) {
      trackCustomWizard({
        ...rest,
        actionDetail: `${rest.actionDetail}: ${fieldsErrors.join(', ')}`,
        action: 'field validation error',
      });

      setLoggedErrors(newErrors);
    }
  }, [fieldsErrors, loggedErrors, rest, trackCustomWizard]);
};

type TrackFormInvalidSubmit = {
  fieldValues: string[];
} & Omit<WizardSimpleOptions, 'action'>;

export const useTrackingCustomWizardInvalidSubmit = (props: TrackFormInvalidSubmit) => {
  const { trackCustomWizard } = useTrackingContext();
  const { fieldValues, ...rest } = props;

  const handleInvalidSubmit = () => {
    const hasMissingFields = fieldValues.some((field) => !field);

    if (hasMissingFields) {
      trackCustomWizard({
        ...rest,
        action: 'field validation error',
      });
    }
  };

  return { handleInvalidSubmit };
};
